export const parseCompanyId = company => company?.general?.id;
